import React from 'react';
import PropTypes from 'prop-types';

import EditIcon from '../../../../Assets/images/svg/dar_pencil_gray_opacity.svg';
import { normalizeRagAccentColor } from '../../../../Utils/ragAccent';

const normalizeStatusClass = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

const FIXED_STATUS_CLASSES = new Set(['on-hold', 'dropped', 'closed', 'in-progress']);

const normalizeHexColor = (value) => {
  const raw = String(value || '').trim();
  const hex = raw.startsWith('#') ? raw.slice(1) : raw;

  if (/^[0-9a-fA-F]{3}$/.test(hex)) {
    return `#${hex.split('').map((ch) => ch + ch)
      .join('')
      .toLowerCase()}`;
  }

  if (/^[0-9a-fA-F]{6}$/.test(hex)) {
    return `#${hex.toLowerCase()}`;
  }

  return '';
};

const ProjectHeaderSection = ({
  title,
  status,
  statusTextColor,
  accentColor,
  client,
  onEditStatus,
  onEdit,
}) => {
  const normalizedStatus = normalizeStatusClass(status);
  const normalizedTextColor = normalizeHexColor(statusTextColor);
  const normalizedAccentColor = normalizeRagAccentColor(accentColor);
  const headerAccentColor = normalizedAccentColor || '#f1f5f8';
  const shouldUseCustomTextColor = normalizedTextColor && !FIXED_STATUS_CLASSES.has(normalizedStatus);

  return (
    <div
      className={`page-header ${normalizedAccentColor ? 'has-accent' : 'no-accent'}`}
      style={{ '--project-header-accent': headerAccentColor }}
    >
      <div className="header-content">
        <div className="left-accent" style={{ backgroundColor: headerAccentColor }} />
        <div className="title-section">
          <h2 className="project-title">{title}</h2>
          <div
            className={`status-badge ${normalizedStatus}`}
            style={{
              ...(shouldUseCustomTextColor ? {
                '--status-badge-text': normalizedTextColor,
                '--status-badge-icon': normalizedTextColor,
              } : null),
            }}
          >
            <span className="badge-text">{status}</span>
            {onEditStatus ? (
              <button
                className="edit-badge-btn"
                aria-label="Edit status"
                type="button"
                onClick={onEditStatus}
              >
                <img src={EditIcon} alt="" />
              </button>
            ) : null}
          </div>
        </div>
        <div className="divider" />
        <div className="client-name">{client}</div>
      </div>
      <div className="header-controls">
        {onEdit ? (
          <button
            className="control-btn edit-btn"
            aria-label="Edit"
            type="button"
            onClick={onEdit}
          >
            <img src={EditIcon} alt="" />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default ProjectHeaderSection;

ProjectHeaderSection.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  statusTextColor: PropTypes.string,
  accentColor: PropTypes.string,
  client: PropTypes.string.isRequired,
  onEditStatus: PropTypes.func,
  onEdit: PropTypes.func,
};

ProjectHeaderSection.defaultProps = {
  statusTextColor: '',
  accentColor: '',
  onEditStatus: null,
  onEdit: null,
};
